import { getAnonymousId } from "./anonymous-id";
import { CartSubmitData } from "./cart-submit-data";
import { UrlHelper } from "./url-helper";

export class ShopifyClient {
    public constructor(private _shopifyClientSettings: { cartUrl: string }) { } 

    public async changeLineItem(data: CartSubmitData | Record<string, any>) {
        const changeAddress = this.buildChangeLineItemAddress();

        return await this._post(changeAddress, data);
    }

    public async addToCart(data: Array<CartSubmitData | Record<string, any>>) {
        const submitAddress = this.buildSubmitCartAddress();
        const formData = {
            items: (Array.isArray(data)) ? data : [data],
        };
        return await this._post(submitAddress, formData);
    }

    public goToCartPage() {
        location.href = this._shopifyClientSettings.cartUrl;
    }

    public buildStorefrontUserId(shopDomain: string, customerId?: string) {
        const isAnonymousUser = customerId == null;

        return isAnonymousUser ? this.buildAnonymousStorefrontUserId() : this.buildSignedInStorefrontUserId(shopDomain, customerId); 
    }

    public getCurrentProductQuantity(): number {

        let url = document.location.href;
        var queryParams = this.getQueryParameters(url);
        var quantity = queryParams['quantity'] ? Number(queryParams['quantity']) : null;

        
        if(!quantity) {
            quantity = !queryParams ? queryParams['quantity'] : 1;
        }

        return quantity;
    }

    private getQueryParameters(str: string) {
        var result = (str || document.location.search).replace(/(^\?)/, '').split("&").map(function(n) {
            return n = n.split("="), this[n[0]] = n[1], this
        }.bind({}))[0];
        delete result[""];

        Object.keys(result).forEach(function(key) {
            result[key] = decodeURIComponent(result[key]);
        });

        if (Object.keys(result).length == 0 && result.constructor === Object) {
            result = {};
        }

        return result;
    }

    private buildSignedInStorefrontUserId(shopDomain: string, customerId: string) {
        const firstDomainSegment = shopDomain.split('.')[0];

        return `shopify_${firstDomainSegment}_${customerId}`;
    }

    private buildAnonymousStorefrontUserId() {
        return `shopify_${this.getSessionId()}`;
    }

    private getSessionId(): string {
        return getAnonymousId();
    }

    private buildChangeLineItemAddress() {
        if (UrlHelper.isAbsolute(this._shopifyClientSettings.cartUrl)) {
            return UrlHelper.urlCombine(this._shopifyClientSettings.cartUrl, 'change.js').toString();
        }
        else {
            return UrlHelper.relativeUrlCombine(this._shopifyClientSettings.cartUrl, 'change.js');
        }
    }

    private buildSubmitCartAddress() {
        if (UrlHelper.isAbsolute(this._shopifyClientSettings.cartUrl)) {
            return UrlHelper.urlCombine(this._shopifyClientSettings.cartUrl, 'add.js').toString();
        }
        else {
            return UrlHelper.relativeUrlCombine(this._shopifyClientSettings.cartUrl, 'add.js');
        }
    }

    private async _post(url: string, formData: Record<string, any>): Promise<Record<string, any>[]> {
        return await fetch(url, {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(formData),
        }).then(res => res.json());
    }

    private JSON_to_URLEncoded(
        element: any,
        key: string | null = null,
        list: string[] = []
    ): string {
        if (element === null || element === undefined) {
            return list.join('&');
        }

        if (typeof element === 'object') {
            if (Array.isArray(element)) {
            element.forEach((item, i) => {
                const newKey = key ? `${key}[${i}]` : `${i}`;
                this.JSON_to_URLEncoded(item, newKey, list);
            });
            } else {
            for (const [k, v] of Object.entries(element)) {
                const newKey = key ? `${key}[${k}]` : k;
                this.JSON_to_URLEncoded(v, newKey, list);
            }
            }
        } else {
            const encodedKey = encodeURIComponent(key ?? '');
            const encodedValue = encodeURIComponent(String(element));
            list.push(`${encodedKey}=${encodedValue}`);
        }

        return list.join('&');
    }
}